import React, { useEffect, useState } from 'react';
import { Checkbox, Loader } from 'react-frontier2';
import { useTranslation } from 'react-i18next';

interface CheckboxAsyncProps{
	checked: boolean,
	onChange: (v: boolean)=>void,
	onChecked: (v: boolean)=>Promise<boolean>,
}

var CheckboxAsync = (props: CheckboxAsyncProps)=>{
	var { t } = useTranslation();
	var [loading, setLoading] = useState<boolean>(false);

	var onCheckboxChange = (val: boolean)=>{
		setLoading(true);
		props.onChecked(val).then(check=>{
			if(check===true){
				props.onChange(val);
			}
		}).catch(err=>{

		}).finally(()=>{
			setLoading(false);
		})
	}
	
	if(loading){
		return <Loader inline size={25} style={{ width: 45 }} />
	}
	return <Checkbox checked={props.checked} onChange={onCheckboxChange} />
}

export default CheckboxAsync;